import { useState } from "react";
import useOnce from "@/utils/hooks/useOnce";

// Making a generic function for extracting timestamps to a use effect to ensure client side rendering,
// should not be needed but this NEXTJS bug https://github.com/vercel/next.js/issues/61911
// is causing the suppressHydrationWarning to cancel hydration.  This can be reverted if the bug is ever fixed.
// Most of the functions in the date utils should work here.

type isoString = string | undefined | null;

interface TimeStampClientProps {
  formatter: (isoString: string) => string;
  isoString: isoString;
}

export default function TimeStampClient({
  isoString,
  formatter,
}: TimeStampClientProps) {
  const [timestamp, setTimestamp] = useState("");

  useOnce(() => {
    if (isoString != null) {
      setTimestamp(formatter(isoString));
    }
  });

  return timestamp;
}
